import { forwardRef } from 'react'

import { cn } from '@/lib/utils'

export const StatusBadge = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    text: string
    status: 'normal' | 'alert' | 'success'
  }
>(({ text, status, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'w-fit whitespace-nowrap rounded-md px-1.5',
        'text-xs font-medium leading-5',
        {
          'bg-blue-100': status === 'success',
          'bg-red-100': status === 'alert',
          'bg-green-100': status === 'normal',
        },
        className
      )}
      {...props}
    >
      {text}
    </div>
  )
})

StatusBadge.displayName = 'StatusBadge'
